import { GenericLandingCardHeader } from "./shared/GenericLandingCardHeader";
import {
  setPasswordTitle,
  setPasswordSubTitle,
  inputNuovaPassword,
  inputConfermaPassword,
  formSetRegisterPassword,
  snackbarRegistrationCompletedTitle,
  snackbarRegistrationCompletedSubTitle,
} from "../_constants";
import { PasswordInput } from "./shared/inputs";
import {
  activationAccount,
  resetPassword,
} from "services/AuthenticationService";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";
import { useSnackbar } from "providers/SnackbarProvider";

export const SetPasswordForm = ({
  control,
  watch,
  trigger,
  handleSubmit,
}: any) => {
  const newPass = watch("password");
  const token = useAppSelector((state) => state.tokenSlice.token);
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const verificationType = useAppSelector(
    (state) => state.tokenVerificationSlice.verificationType
  );

  const onSubmit = (data: any) => {
    const request = {
      token: token,
      password: data.password,
    };
    if (verificationType === "registration") {
      activationAccount(request)
        .then(() => {
          navigate("/");
          showSnackbar({
            severity: "success",
            summary: snackbarRegistrationCompletedTitle,
            detail: snackbarRegistrationCompletedSubTitle,
            life: 5000,
          });
        })
        .catch((_) => {});
    } else if (verificationType === "passwordReset") {
      resetPassword(request)
        .then(() => {
          navigate("/");
        })
        .catch((_) => {});
    }
  };

  return (
    <div>
      <GenericLandingCardHeader
        title={setPasswordTitle}
        subtitle={setPasswordSubTitle}
      ></GenericLandingCardHeader>
      <form
        className="margin-top-32"
        id={formSetRegisterPassword}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="width-100 container-flex justify-between wrap">
          <div className="width-100 margin-bottom-8">
            <PasswordInput
              control={control}
              name="password"
              placeholder={inputNuovaPassword}
              feedback={true}
              triggerEvent={() => trigger("confirmPassword")}
            />
          </div>
          <div className="width-100 margin-bottom-8">
            <PasswordInput
              control={control}
              name="confirmPassword"
              placeholder={inputConfermaPassword}
              password={newPass}
            />
          </div>
        </div>
      </form>
    </div>
  );
};
